import styled from "styled-components"
import { useState } from "react"
import Button from "../../components/shared/button/Btn"
import loginTruck from "../../images/img/login-truck.jpg";
import { sendMailAdresForVerification, sendMailAdresForVerificationForgot, sendNewPassword, setForgotData } from "../../features/auth/authSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import InputMail from "../../components/shared/input/new/InputMail"
import SmallSpinner from "../../components/shared/spinners/SmallSpinner";
import RegisterModalLayout from "../../layouts/RegisterModalLayout";
import InputPassword from "../../components/shared/input/new/InputPassword";
import { Link } from "react-router-dom";
import {showRegisterModal} from "../../features/register/registerSlice";
const Container = styled.div`
  width: 100%;
  height: 100vh;
  .login-container {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    @media (max-width: 992px) {
      flex-direction: column;
    }

    .left {
      height: 100%;
      width: 50%;
      @media (max-width: 992px) {
        display: none;
      }
      .imageBox {
        height: 100%;
        width: 100%;
        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
      }
    }

    .right {
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      margin: 0 auto;
      flex-direction: column;
      @media (max-width: 992px) {
        width: 100%;
      }

      h1 {
        margin-bottom: 20px;
        font-size: 18px;
        font-weight: 600;
        line-height: 16px;
      }
      .form {
        width: 500px;
        & > div {
          margin-block: 15px;
        }
        @media (max-width: 1200px) {
          width: 70%;
        }
        .error{
          font-size: var(--font-size-sm);
          color: var(--color-main);
          font-weight: var(--font-weight-md);
        }

        .link{
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
          a{
            color: var(--color-main);
          }
        }
      }

      .button-container {
        display: flex;
        flex-direction: column;

        button {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 10px;
          padding: 10px 5px;
          width: 100%;
          border-radius: 5px;
          height: 36px;
          background-color: var(--color-main);
          font-family: Raleway;
          font-size: 14px;
          font-weight: 500;
          line-height: 16px;
        }
      }
    }
    .message-container{
      font-size: var(--font-size-sm);
      color: var(--color-main);
    }
  }
`
    
const ForgotPassword = () => {
    const dispatch = useDispatch()
    const {forgotData, isLoadingSendMail, isLoadingNewPassword, isSuccessVerification, message, forgotPasswordVerificationStatus, isLoadingSendVerification} = useSelector(state => state.auth)
    const [isShowFirst, setIsShowFirst] = useState(false)
    const [isShowSec, setIsShowSec] = useState(false)
    const [isSubmitted, setIsSubmitted] = useState(false)

    const handleChange = (e)=> {
      dispatch(setForgotData({[e.target.name]: e.target.value}))
    }



    const sendPassword = () => {
      setIsSubmitted(true)
      if(isSubmitted && (forgotData?.password1 === forgotData?.password2)){
        const addData= {
          email: forgotData.email, 
          password: forgotData?.password1
        }
        dispatch(sendNewPassword(addData))
      }
      
    }

    const showPasswordFirst = () => {
      setIsShowFirst((prev) => !prev)
    }
    
    const showPasswordSec = () => {
      setIsShowSec((prev) => !prev)
    }

    const sendCode = () => {
      
      if(forgotPasswordVerificationStatus){
        dispatch(showRegisterModal("forgotVerificationCode"))
      }
      
      else{
        dispatch(sendMailAdresForVerificationForgot({email: forgotData.email}))
      }
    }

 
  return (
    <Container>
      <RegisterModalLayout />
      <div className="login-container">
        <div className="left">
          <div className="imageBox">
            <img src={loginTruck} alt="login-truck" />
          </div>
        </div>

        <div className="right">
          {
            isSuccessVerification ? 
            <>
              <h1>Şifre Belirleme</h1>

              <div className="form">
                <InputPassword data={forgotData?.password1} setData={handleChange} type={isShowFirst ? "text" : "password"} name={"password1"} labelText={"Şifre"} showPassword={showPasswordFirst} isShow={isShowFirst} />
                <InputPassword data={forgotData?.password2} setData={handleChange} type={isShowSec ? "text" : "password"} name={"password2"} labelText={"Şifre Tekrar"} showPassword={showPasswordSec} isShow={isShowSec} />
                {
                  (forgotData?.password1 !== forgotData?.password2) && isSubmitted && 
                  <div className="error">
                    Şifreler aynı olmalı.
                  </div>
                }
                <div className="button-container">
                  <Button type="text" handleClick={sendPassword} color={"#FFF"}>{isLoadingNewPassword ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Gönder"}</Button>
                </div>
              </div>
            </>

            :
            <>
              <h1>Şifremi Unuttum</h1>
              <div className="form">
                <InputMail setData={handleChange} data={forgotData?.email} labelText={"Mail Adresi"} name={"email"} />
                {message &&
                  <div className="error">
                    {message}
                  </div>
                }
                
                <div className="button-container">
                  <Button type="text" handleClick={() => sendCode()} color={"#FFF"}>{isLoadingSendMail ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : forgotPasswordVerificationStatus ? "Kodu Gir" : "Kodu Gönder"}</Button>
                </div>

                <div className="link">
                  <p>Şifrenizi hatırlıyor musunuz? <Link to="/giris-yap">Giriş yapın.</Link></p> 
                </div>
              </div>
            </>
          }
          
        </div>
      </div>
    </Container>
  )
}

export default ForgotPassword